/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../generated/graphql/types';
import { BannerCampaignFieldsFragmentDoc } from './banner-campaign.fragment.generated';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OngletBannerCampaignsQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
}>;

export type OngletBannerCampaignsQuery = { __typename?: 'Query' } & {
  bannerCampaigns: Types.Maybe<
    Array<
      { __typename?: 'BannerCampaign' } & Pick<
        Types.BannerCampaign,
        | 'name'
        | 'id'
        | 'attributes'
        | 'userSegments'
        | 'title'
        | 'sponsor'
        | 'advertiser'
        | 'pageType'
        | 'trackingId'
      > & {
          image: Types.Maybe<
            { __typename?: 'BannerCampaignImage' } & Pick<
              Types.BannerCampaignImage,
              'desktopUrl' | 'mobileUrl' | 'altText'
            >
          >;
          link: Types.Maybe<
            { __typename?: 'BannerCampaignLink' } & Pick<
              Types.BannerCampaignLink,
              'url' | 'target'
            >
          >;
          abTest: Types.Maybe<
            { __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'feature'>
          >;
          featureFlag: Types.Maybe<
            { __typename?: 'FeatureFlag' } & Pick<
              Types.FeatureFlag,
              'id' | 'active'
            >
          >;
        }
    >
  >;
};

export type HomepageSecondaryPromotionCampaignsQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
}>;

export type HomepageSecondaryPromotionCampaignsQuery = {
  __typename?: 'Query';
} & {
  bannerCampaigns: Types.Maybe<
    Array<
      { __typename?: 'BannerCampaign' } & Pick<
        Types.BannerCampaign,
        | 'name'
        | 'id'
        | 'attributes'
        | 'userSegments'
        | 'title'
        | 'sponsor'
        | 'advertiser'
        | 'pageType'
        | 'trackingId'
      > & {
          image: Types.Maybe<
            { __typename?: 'BannerCampaignImage' } & Pick<
              Types.BannerCampaignImage,
              'desktopUrl' | 'mobileUrl' | 'altText'
            >
          >;
          link: Types.Maybe<
            { __typename?: 'BannerCampaignLink' } & Pick<
              Types.BannerCampaignLink,
              'url' | 'target'
            >
          >;
          abTest: Types.Maybe<
            { __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'feature'>
          >;
          featureFlag: Types.Maybe<
            { __typename?: 'FeatureFlag' } & Pick<
              Types.FeatureFlag,
              'id' | 'active'
            >
          >;
        }
    >
  >;
};

export type ProLandingPageMainCampaignsQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
}>;

export type ProLandingPageMainCampaignsQuery = { __typename?: 'Query' } & {
  bannerCampaigns: Types.Maybe<
    Array<
      { __typename?: 'BannerCampaign' } & Pick<
        Types.BannerCampaign,
        | 'name'
        | 'id'
        | 'attributes'
        | 'userSegments'
        | 'title'
        | 'sponsor'
        | 'advertiser'
        | 'pageType'
        | 'trackingId'
      > & {
          image: Types.Maybe<
            { __typename?: 'BannerCampaignImage' } & Pick<
              Types.BannerCampaignImage,
              'desktopUrl' | 'mobileUrl' | 'altText'
            >
          >;
          link: Types.Maybe<
            { __typename?: 'BannerCampaignLink' } & Pick<
              Types.BannerCampaignLink,
              'url' | 'target'
            >
          >;
          abTest: Types.Maybe<
            { __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'feature'>
          >;
          featureFlag: Types.Maybe<
            { __typename?: 'FeatureFlag' } & Pick<
              Types.FeatureFlag,
              'id' | 'active'
            >
          >;
        }
    >
  >;
};

export type HomepageSecondaryCampaignsQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
}>;

export type HomepageSecondaryCampaignsQuery = { __typename?: 'Query' } & {
  bannerCampaigns: Types.Maybe<
    Array<
      { __typename?: 'BannerCampaign' } & Pick<
        Types.BannerCampaign,
        | 'name'
        | 'id'
        | 'attributes'
        | 'userSegments'
        | 'title'
        | 'sponsor'
        | 'advertiser'
        | 'pageType'
        | 'trackingId'
      > & {
          image: Types.Maybe<
            { __typename?: 'BannerCampaignImage' } & Pick<
              Types.BannerCampaignImage,
              'desktopUrl' | 'mobileUrl' | 'altText'
            >
          >;
          link: Types.Maybe<
            { __typename?: 'BannerCampaignLink' } & Pick<
              Types.BannerCampaignLink,
              'url' | 'target'
            >
          >;
          abTest: Types.Maybe<
            { __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'feature'>
          >;
          featureFlag: Types.Maybe<
            { __typename?: 'FeatureFlag' } & Pick<
              Types.FeatureFlag,
              'id' | 'active'
            >
          >;
        }
    >
  >;
};

export type ListingMiddleTechnicalCampaignsQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
  categoryIds?: Types.InputMaybe<
    Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']
  >;
}>;

export type ListingMiddleTechnicalCampaignsQuery = { __typename?: 'Query' } & {
  listingCampaigns: Types.Maybe<
    Array<
      { __typename?: 'BannerCampaign' } & Pick<
        Types.BannerCampaign,
        | 'name'
        | 'id'
        | 'attributes'
        | 'userSegments'
        | 'title'
        | 'sponsor'
        | 'advertiser'
        | 'pageType'
        | 'trackingId'
      > & {
          image: Types.Maybe<
            { __typename?: 'BannerCampaignImage' } & Pick<
              Types.BannerCampaignImage,
              'desktopUrl' | 'mobileUrl' | 'altText'
            >
          >;
          link: Types.Maybe<
            { __typename?: 'BannerCampaignLink' } & Pick<
              Types.BannerCampaignLink,
              'url' | 'target'
            >
          >;
          abTest: Types.Maybe<
            { __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'feature'>
          >;
          featureFlag: Types.Maybe<
            { __typename?: 'FeatureFlag' } & Pick<
              Types.FeatureFlag,
              'id' | 'active'
            >
          >;
        }
    >
  >;
};

export type ListingBottomTechnicalCampaignsQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
  categoryIds?: Types.InputMaybe<
    Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']
  >;
}>;

export type ListingBottomTechnicalCampaignsQuery = { __typename?: 'Query' } & {
  listingCampaigns: Types.Maybe<
    Array<
      { __typename?: 'BannerCampaign' } & Pick<
        Types.BannerCampaign,
        | 'name'
        | 'id'
        | 'attributes'
        | 'userSegments'
        | 'title'
        | 'sponsor'
        | 'advertiser'
        | 'pageType'
        | 'trackingId'
      > & {
          image: Types.Maybe<
            { __typename?: 'BannerCampaignImage' } & Pick<
              Types.BannerCampaignImage,
              'desktopUrl' | 'mobileUrl' | 'altText'
            >
          >;
          link: Types.Maybe<
            { __typename?: 'BannerCampaignLink' } & Pick<
              Types.BannerCampaignLink,
              'url' | 'target'
            >
          >;
          abTest: Types.Maybe<
            { __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'feature'>
          >;
          featureFlag: Types.Maybe<
            { __typename?: 'FeatureFlag' } & Pick<
              Types.FeatureFlag,
              'id' | 'active'
            >
          >;
        }
    >
  >;
};

export type HeaderBannerCampaignsQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
}>;

export type HeaderBannerCampaignsQuery = { __typename?: 'Query' } & {
  bannerCampaigns: Types.Maybe<
    Array<
      { __typename?: 'BannerCampaign' } & Pick<
        Types.BannerCampaign,
        | 'name'
        | 'id'
        | 'attributes'
        | 'userSegments'
        | 'title'
        | 'sponsor'
        | 'advertiser'
        | 'pageType'
        | 'trackingId'
      > & {
          image: Types.Maybe<
            { __typename?: 'BannerCampaignImage' } & Pick<
              Types.BannerCampaignImage,
              'desktopUrl' | 'mobileUrl' | 'altText'
            >
          >;
          link: Types.Maybe<
            { __typename?: 'BannerCampaignLink' } & Pick<
              Types.BannerCampaignLink,
              'url' | 'target'
            >
          >;
          abTest: Types.Maybe<
            { __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'feature'>
          >;
          featureFlag: Types.Maybe<
            { __typename?: 'FeatureFlag' } & Pick<
              Types.FeatureFlag,
              'id' | 'active'
            >
          >;
        }
    >
  >;
};

export type HomepageTertiaryCampaignsQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
}>;

export type HomepageTertiaryCampaignsQuery = { __typename?: 'Query' } & {
  homepageTertiary: Types.Maybe<
    Array<
      { __typename?: 'BannerCampaign' } & Pick<
        Types.BannerCampaign,
        | 'name'
        | 'id'
        | 'attributes'
        | 'userSegments'
        | 'title'
        | 'sponsor'
        | 'advertiser'
        | 'pageType'
        | 'trackingId'
      > & {
          image: Types.Maybe<
            { __typename?: 'BannerCampaignImage' } & Pick<
              Types.BannerCampaignImage,
              'desktopUrl' | 'mobileUrl' | 'altText'
            >
          >;
          link: Types.Maybe<
            { __typename?: 'BannerCampaignLink' } & Pick<
              Types.BannerCampaignLink,
              'url' | 'target'
            >
          >;
          abTest: Types.Maybe<
            { __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'feature'>
          >;
          featureFlag: Types.Maybe<
            { __typename?: 'FeatureFlag' } & Pick<
              Types.FeatureFlag,
              'id' | 'active'
            >
          >;
        }
    >
  >;
};

export type MenuCategoryCampaignsQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
  categoryIds?: Types.InputMaybe<
    Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']
  >;
}>;

export type MenuCategoryCampaignsQuery = { __typename?: 'Query' } & {
  bannerCampaigns: Types.Maybe<
    Array<
      { __typename?: 'BannerCampaign' } & Pick<
        Types.BannerCampaign,
        | 'name'
        | 'id'
        | 'attributes'
        | 'userSegments'
        | 'title'
        | 'sponsor'
        | 'advertiser'
        | 'pageType'
        | 'trackingId'
      > & {
          image: Types.Maybe<
            { __typename?: 'BannerCampaignImage' } & Pick<
              Types.BannerCampaignImage,
              'desktopUrl' | 'mobileUrl' | 'altText'
            >
          >;
          link: Types.Maybe<
            { __typename?: 'BannerCampaignLink' } & Pick<
              Types.BannerCampaignLink,
              'url' | 'target'
            >
          >;
          abTest: Types.Maybe<
            { __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'feature'>
          >;
          featureFlag: Types.Maybe<
            { __typename?: 'FeatureFlag' } & Pick<
              Types.FeatureFlag,
              'id' | 'active'
            >
          >;
        }
    >
  >;
};

export const OngletBannerCampaignsDocument = /*#__PURE__*/ `
    query OngletBannerCampaigns($platform: Platform!, $market: Market!, $userSegments: Map) {
  bannerCampaigns: bannerCampaigns(
    market: $market
    platform: $platform
    space: ONGLET_BANNER
    userSegments: $userSegments
  ) {
    ...BannerCampaignFields
  }
}
    ${BannerCampaignFieldsFragmentDoc}`;

export function useOngletBannerCampaignsQuery(
  options: Omit<
    Urql.UseQueryArgs<OngletBannerCampaignsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OngletBannerCampaignsQuery,
    OngletBannerCampaignsQueryVariables
  >({ query: OngletBannerCampaignsDocument, ...options });
}
export const HomepageSecondaryPromotionCampaignsDocument = /*#__PURE__*/ `
    query HomepageSecondaryPromotionCampaigns($platform: Platform!, $market: Market!, $userSegments: Map) {
  bannerCampaigns: bannerCampaigns(
    market: $market
    platform: $platform
    space: HOMEPAGE_SECONDARY_PROMOTION
    userSegments: $userSegments
  ) {
    ...BannerCampaignFields
  }
}
    ${BannerCampaignFieldsFragmentDoc}`;

export function useHomepageSecondaryPromotionCampaignsQuery(
  options: Omit<
    Urql.UseQueryArgs<HomepageSecondaryPromotionCampaignsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    HomepageSecondaryPromotionCampaignsQuery,
    HomepageSecondaryPromotionCampaignsQueryVariables
  >({ query: HomepageSecondaryPromotionCampaignsDocument, ...options });
}
export const ProLandingPageMainCampaignsDocument = /*#__PURE__*/ `
    query ProLandingPageMainCampaigns($platform: Platform!, $market: Market!, $userSegments: Map) {
  bannerCampaigns: bannerCampaigns(
    market: $market
    platform: $platform
    space: PRO_LANDING_PAGE_MAIN
    userSegments: $userSegments
  ) {
    ...BannerCampaignFields
  }
}
    ${BannerCampaignFieldsFragmentDoc}`;

export function useProLandingPageMainCampaignsQuery(
  options: Omit<
    Urql.UseQueryArgs<ProLandingPageMainCampaignsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ProLandingPageMainCampaignsQuery,
    ProLandingPageMainCampaignsQueryVariables
  >({ query: ProLandingPageMainCampaignsDocument, ...options });
}
export const HomepageSecondaryCampaignsDocument = /*#__PURE__*/ `
    query HomepageSecondaryCampaigns($platform: Platform!, $market: Market!, $userSegments: Map) {
  bannerCampaigns: bannerCampaigns(
    market: $market
    platform: $platform
    space: HOMEPAGE_SECONDARY
    userSegments: $userSegments
  ) {
    ...BannerCampaignFields
  }
}
    ${BannerCampaignFieldsFragmentDoc}`;

export function useHomepageSecondaryCampaignsQuery(
  options: Omit<
    Urql.UseQueryArgs<HomepageSecondaryCampaignsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    HomepageSecondaryCampaignsQuery,
    HomepageSecondaryCampaignsQueryVariables
  >({ query: HomepageSecondaryCampaignsDocument, ...options });
}
export const ListingMiddleTechnicalCampaignsDocument = /*#__PURE__*/ `
    query ListingMiddleTechnicalCampaigns($platform: Platform!, $market: Market!, $userSegments: Map, $categoryIds: [Int!]) {
  listingCampaigns: bannerCampaigns(
    market: $market
    platform: $platform
    space: LISTING_MIDDLE_TECHNICAL
    userSegments: $userSegments
    categoryIds: $categoryIds
  ) {
    ...BannerCampaignFields
  }
}
    ${BannerCampaignFieldsFragmentDoc}`;

export function useListingMiddleTechnicalCampaignsQuery(
  options: Omit<
    Urql.UseQueryArgs<ListingMiddleTechnicalCampaignsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ListingMiddleTechnicalCampaignsQuery,
    ListingMiddleTechnicalCampaignsQueryVariables
  >({ query: ListingMiddleTechnicalCampaignsDocument, ...options });
}
export const ListingBottomTechnicalCampaignsDocument = /*#__PURE__*/ `
    query ListingBottomTechnicalCampaigns($platform: Platform!, $market: Market!, $userSegments: Map, $categoryIds: [Int!]) {
  listingCampaigns: bannerCampaigns(
    market: $market
    platform: $platform
    space: LISTING_BOTTOM_TECHNICAL
    userSegments: $userSegments
    categoryIds: $categoryIds
  ) {
    ...BannerCampaignFields
  }
}
    ${BannerCampaignFieldsFragmentDoc}`;

export function useListingBottomTechnicalCampaignsQuery(
  options: Omit<
    Urql.UseQueryArgs<ListingBottomTechnicalCampaignsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ListingBottomTechnicalCampaignsQuery,
    ListingBottomTechnicalCampaignsQueryVariables
  >({ query: ListingBottomTechnicalCampaignsDocument, ...options });
}
export const HeaderBannerCampaignsDocument = /*#__PURE__*/ `
    query HeaderBannerCampaigns($platform: Platform!, $market: Market!, $userSegments: Map) {
  bannerCampaigns(
    market: $market
    platform: $platform
    space: HEADER_BANNER
    userSegments: $userSegments
  ) {
    ...BannerCampaignFields
  }
}
    ${BannerCampaignFieldsFragmentDoc}`;

export function useHeaderBannerCampaignsQuery(
  options: Omit<
    Urql.UseQueryArgs<HeaderBannerCampaignsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    HeaderBannerCampaignsQuery,
    HeaderBannerCampaignsQueryVariables
  >({ query: HeaderBannerCampaignsDocument, ...options });
}
export const HomepageTertiaryCampaignsDocument = /*#__PURE__*/ `
    query HomepageTertiaryCampaigns($platform: Platform!, $market: Market!, $userSegments: Map) {
  homepageTertiary: bannerCampaigns(
    market: $market
    platform: $platform
    space: HOMEPAGE_TERTIARY
    userSegments: $userSegments
  ) {
    ...BannerCampaignFields
  }
}
    ${BannerCampaignFieldsFragmentDoc}`;

export function useHomepageTertiaryCampaignsQuery(
  options: Omit<
    Urql.UseQueryArgs<HomepageTertiaryCampaignsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    HomepageTertiaryCampaignsQuery,
    HomepageTertiaryCampaignsQueryVariables
  >({ query: HomepageTertiaryCampaignsDocument, ...options });
}
export const MenuCategoryCampaignsDocument = /*#__PURE__*/ `
    query MenuCategoryCampaigns($platform: Platform!, $market: Market!, $userSegments: Map, $categoryIds: [Int!]) {
  bannerCampaigns(
    market: $market
    platform: $platform
    space: MENU_CATEGORY
    userSegments: $userSegments
    categoryIds: $categoryIds
  ) {
    ...BannerCampaignFields
  }
}
    ${BannerCampaignFieldsFragmentDoc}`;

export function useMenuCategoryCampaignsQuery(
  options: Omit<
    Urql.UseQueryArgs<MenuCategoryCampaignsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    MenuCategoryCampaignsQuery,
    MenuCategoryCampaignsQueryVariables
  >({ query: MenuCategoryCampaignsDocument, ...options });
}
